import { useState, useEffect } from "react";
import { getAllPermissions, getRolesAndPermissions } from "store/data-slice";
import { useDispatch } from "react-redux";
import LoadingPage from "pages/General/LoadingPage/LoadingPage";

const UsePermission = (props) => {
    const { children } = props;
    const [ loaded, setLoaded ] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (loaded === false) {
            load().then(() => {
                setLoaded(true);
            })
        }
    }, [])

    const load = async () => {
        return Promise.all([
            await dispatch(getAllPermissions(true)),
            await dispatch(getRolesAndPermissions(true))
        ])
    }

    return (
        <>
            { loaded ? children : <LoadingPage /> }
        </>
    )
}

export default UsePermission;